import { createSlice } from '@reduxjs/toolkit';
import { streamApi } from '../functions/streamApi';

const initialState = {
  incidentsCoordinates: [],
  loading: false,
};

export const incidentsMapReducer = createSlice({
  name: 'incidentsReducer',
  initialState,
  reducers: {
    setIncidentsCoordinates: (state, action) => {
      state.incidentsCoordinates = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    addIncidentCoordinate: (state, action) => {
      state.incidentsCoordinates = [
        ...state.incidentsCoordinates,
        action.payload,
      ];
    },
  },
});

export const { setIncidentsCoordinates, setLoading, addIncidentCoordinate } =
  incidentsMapReducer.actions;

export default incidentsMapReducer.reducer;

export const getIncidentsOverview = (dateRange) => async (dispatch) => {
  try {
    // dispatch(setLoading(true));
    // dispatch(setIncidentsCoordinates([])); // очищаємо перед новим запитом

    await streamApi.streamIncidentsCoordinates(
      dateRange,
      (chunk) => {
        // console.log('chunk', chunk);
        dispatch(addIncidentCoordinate(chunk));
      },
      (lastIncident) => {
        console.log('lastIncident', lastIncident);
        dispatch(setIncidentsCoordinates(lastIncident));
      }
    );
  } catch (err) {
    console.error('Stream error:', err);
  } finally {
    // dispatch(setLoading(false));
  }
};

// export const getIncidentsOverview = (dateRange) => async (dispatch) => {
//   try {
//     dispatch(setLoading(true));
//     const response = await incidentsApi.getIncidentsCoordinates(dateRange);

//     if (response.status === 200) {
//       dispatch(setIncidentsCoordinates(response.data));
//     } else throw new Error('No data received from API');
//   } catch (err) {
//     console.log(err);
//   } finally {
//     dispatch(setLoading(false));
//   }
// };
